/**
 * moon-image-fix.js
 * Patches simply.product image swap to work with MERGED theme DOM structure.
 */
(function () {
  'use strict';

  function getGalleryContainer() {
    return document.querySelector('product-images') ||
           document.querySelector('.product__slides');
  }

  function getSlidesContainer() {
    var gallery = getGalleryContainer();
    if (!gallery) return null;
    return gallery.querySelector('[data-product-media-list]') ||
      gallery.querySelector('.product__slides') ||
      document.querySelector('[data-product-media-list]') ||
      document.querySelector('.product__slides');
  }

  function getFirstMediaSlide() {
    var slidesContainer = getSlidesContainer();
    if (!slidesContainer) return null;
    return slidesContainer.querySelector('.product__slide[data-media-id]');
  }

  function setSlideImage(slide, url, alt) {
    if (!slide || !url) return;

    var photo = slide.querySelector('.product__photo') || slide;
    var figure = photo.querySelector('figure') || photo.querySelector('.image-wrapper');
    if (!figure) return;

    var imgs = figure.querySelectorAll('img');
    imgs.forEach(function (img) {
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('d-src');
      img.removeAttribute('sizes');
      img.src = url;
      if (alt) img.alt = alt;
    });

    figure.classList.remove('is-loading');

    if (photo.hasAttribute('data-image-src')) {
      photo.setAttribute('data-image-src', url);
    }
  }

  function setFirstThumbImage(url, alt) {
    if (!url) return;
    var firstThumb = document.querySelector('.product__thumbs__holder .product__thumb:first-child');
    if (!firstThumb) return;

    var imgs = firstThumb.querySelectorAll('img');
    imgs.forEach(function (img) {
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('sizes');
      img.src = url;
      if (alt) img.alt = alt;
    });

    firstThumb.classList.remove('is-loading');
  }

  function removeLegacyZodiacMedia() {
    var zodiacSlides = document.querySelectorAll('.zodiac-slide');
    zodiacSlides.forEach(function (zodiacSlide) {
      if (zodiacSlide.parentNode) {
        zodiacSlide.parentNode.removeChild(zodiacSlide);
      }
    });

    var zodiacThumbs = document.querySelectorAll('.zodiac-thumb');
    zodiacThumbs.forEach(function (zodiacThumb) {
      if (zodiacThumb.parentNode) {
        zodiacThumb.parentNode.removeChild(zodiacThumb);
      }
    });
  }

  function activateFirstMedia() {
    var gallery = getGalleryContainer();
    var firstSlide = getFirstMediaSlide();
    if (!gallery || !firstSlide) return;

    var firstMediaId = firstSlide.getAttribute('data-media-id');
    if (!firstMediaId) return;

    gallery.dispatchEvent(new CustomEvent('theme:media:select', {
      bubbles: true,
      detail: { id: firstMediaId }
    }));
  }

  var overlay = null;

  function ensureOverlay() {
    if (overlay && overlay.parentNode) return overlay;
    var container = getGalleryContainer();
    if (!container) return null;
    // Gallery needs relative positioning for the overlay
    if (getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }
    overlay = document.createElement('div');
    overlay.className = 'moon-loading-overlay';
    overlay.innerHTML = '<div class="moon-loading-spinner"></div>';
    container.appendChild(overlay);
    return overlay;
  }

  function showLoader() {
    var el = ensureOverlay();
    if (el) el.classList.add('is-visible');
  }

  function hideLoader() {
    if (overlay) overlay.classList.remove('is-visible');
  }

  /* ── Image swap ── */
  function swapMergedImage(url) {
    if (!url) { hideLoader(); return; }

    var firstSlide = getFirstMediaSlide();
    if (!firstSlide) { hideLoader(); return; }

    setSlideImage(firstSlide, url);
    setFirstThumbImage(url);
    activateFirstMedia();

    // Hide loader once the moon image has loaded
    var testImg = new Image();
    testImg.onload = function () { 
      activateFirstMedia();
      hideLoader(); 
      if (simply.product && simply.product.togglePImageLoading) {
        simply.product.togglePImageLoading(0);
      }
    };
    testImg.onerror = function () { 
      activateFirstMedia();
      hideLoader(); 
      if (simply.product && simply.product.togglePImageLoading) {
        simply.product.togglePImageLoading(0);
      }
    };
    testImg.src = url;
  }

  /* ── Constellation swap ── */
  function swapConstellationImage(url, alt) {
    if (!url) return;

    removeLegacyZodiacMedia();

    var firstSlide = getFirstMediaSlide();
    if (firstSlide) {
      setSlideImage(firstSlide, url, alt);
    }

    setFirstThumbImage(url, alt);
    activateFirstMedia();
  }

  /* ── Legacy price update safety net ──
     simply.js triggerImageChange assumes the old .prod-price .h4-price element
     exists and crashes with "Cannot set properties of null (setting 'innerHTML')"
     on products that use the Broadcast markup ([data-product-price]). The patch in
     snippets/head.liquid fixes this, but on some product pages it does not apply
     in time (likely because simply.js is lazy-loaded via type="load"). This helper
     updates the price using both legacy and modern selectors, and the wrapper
     below catches the original crash so the variant change still succeeds. */
  function isSafeTriggerPatched(fn) {
    return fn && typeof fn.toString === 'function' && fn.toString().indexOf('[data-product-price]') > -1;
  }

  function updatePriceFromLabel(that) {
    if (!that) return;
    var parent = that.closest('.swatch-item');
    if (!parent || !parent.classList.contains('chain-option')) return;

    var price = that.dataset.price;
    var cprice = that.dataset.cPrice;
    if (!price) return;

    var priceEl = document.querySelector('.prod-price .h4-price')
               || document.querySelector('[data-product-price]');
    var cPriceDel = document.querySelector('.prod-price .h4-c-price del')
                 || document.querySelector('[data-compare-price]');
    var cPriceWrap = document.querySelector('.prod-price .h4-c-price')
                  || (cPriceDel ? cPriceDel.parentElement : null);

    if (priceEl) {
      priceEl.innerHTML = price;
      if (cprice) {
        priceEl.classList.add('product__price--sale');
      } else {
        priceEl.classList.remove('product__price--sale');
      }
    }

    if (cprice) {
      if (cPriceDel) cPriceDel.innerHTML = cprice;
      if (cPriceWrap) cPriceWrap.style.display = '';
    } else {
      if (cPriceWrap && cPriceWrap !== priceEl) cPriceWrap.style.display = 'none';
      if (cPriceDel) cPriceDel.innerHTML = '';
    }
  }

  /* ── Install hooks ── */
  function install() {
    if (typeof simply === 'undefined' || !simply.product || !simply.product.createmultiMoonImageAjax || !simply.product.triggerImageChange) {
      return setTimeout(install, 100);
    }

    // Override Zodiac/Constellation Trigger Image Change
    var _origTriggerImageChange = simply.product.triggerImageChange;
    var triggerAlreadySafe = isSafeTriggerPatched(_origTriggerImageChange);

    simply.product.triggerImageChange = function (that) {
      // When head.liquid's safe price patch is missing (e.g. simply.js lazy-load
      // timing), the legacy function crashes on Broadcast products. Update the
      // price safely first, then let the original run inside try/catch.
      if (!triggerAlreadySafe && that) {
        updatePriceFromLabel(that);
      }

      if (_origTriggerImageChange) {
        try {
          _origTriggerImageChange.apply(this, arguments);
        } catch (e) {
          // Swallow only the known legacy null-innerHTML crash; rethrow real errors.
          if (!e || !e.message || e.message.indexOf('Cannot set properties of null') === -1 || e.message.indexOf('innerHTML') === -1) {
            throw e;
          }
        }
      }

      if (that && typeof $ !== 'undefined') {
        var newVariant = $(that).data('val-handle');
        if (!newVariant) return;

        var variantTitleProductImage = false;
        if (simply.productImages) {
          for (var i = 0; i < simply.productImages.length; i++) {
            var productImage = simply.productImages[i];
            
            var handleize = function(str) {
              return (str || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
            };

            var imgAlt = handleize(productImage.image_alt || '');
            var searchVariant = handleize(newVariant);
            
            if (imgAlt.indexOf(searchVariant) > -1) {
              variantTitleProductImage = productImage;
              break;
            }
          }
        }

        if (variantTitleProductImage) {
          // Keep all personalization updates on the first gallery media
          swapConstellationImage(variantTitleProductImage.image_url, variantTitleProductImage.image_alt);
          activateFirstMedia();
        }
      }
    };

    // Catch API proxy success
    var _origAjax = simply.product.createmultiMoonImageAjax;
    simply.product.createmultiMoonImageAjax = function (data, successCB, errorCB) {
      showLoader();
      _origAjax.call(this, data, function (res) {
        if (successCB) successCB(res);
        if (res && res.status == 200 && res.data && res.data.src) {
          swapMergedImage(res.data.src);
        } else {
          hideLoader();
        }
      }, function (err) {
        hideLoader();
        if (errorCB) errorCB(err);
      });
    };

    // Catch direct S3 success (production, where CORS works)
    if (typeof $ !== 'undefined' && $.get) {
      var _origGet = $.get;
      $.get = function () {
        var url = arguments[0];
        var xhr = _origGet.apply($, arguments);
        if (typeof url === 'string' && url.indexOf('moonglowimages') !== -1) {
          showLoader();
          // Do NOT swap the image yet, wait for success!
          xhr.done(function () {
            swapMergedImage(url);
          }).fail(function () {
            // fallback handled by createmultiMoonImageAjax
          });
        }
        return xhr;
      };
    }

    console.log('[moon-image-fix] Installed with external CSS');
  }

  install();
})();